import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonFunctions } from '@shared/common-functions';
import { CancelModalComponent } from '@shared/components/cancel-modal/cancel-modal.component';
import { InvoicePaymentStatus } from '@core/models/api-response.model';
import { CommonMenuService } from '@shared/services/common-util.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { DriverService as SharedDriverService } from '@shared/components/driver/services/driver.service';
import { ToastService } from '@shared/services/toast.service';
import { CANCEL_INVOICE_CONFIRMATION_MODEL, MARK_AS_PAID_CONFIRMATION } from '@shared/constant/shared.constant';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { PayRepayModalComponent } from '@shared/components/pay-repay-modal/pay-repay-modal.component';
import { SuperAdminService } from '@core/services/super-admin.service';
import { SharedInvoicePopupComponent } from '@shared/components/shared-invoice-popup/shared-invoice-popup.component';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-user-crm-custom-invoice',
  templateUrl: './user-crm-custom-invoice.component.html',
  styleUrls: ['./user-crm-custom-invoice.component.scss']
})
export class UserCrmCustomInvoiceComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  @Input() customInvoiceList;
  @Input() itemsPerPage;
  @Input() totalCustomInvoices;
  @Input() BookingCurrentSkip;
  @Input() activeIndex;
  @Input() isGroupUser: boolean = false;
  @Output() pageCustomInvoiceList = new EventEmitter<any>();
  @Output() viewInVoice = new EventEmitter<any>();
  @Output() sendInvoiceOnMail = new EventEmitter<any>();
  @Output() afterCancelApiCall: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterPayApiCall: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterMarkAsPaidOrCancel: EventEmitter<any> = new EventEmitter<any>();
  items: any;
  invoicePaymentStatus = InvoicePaymentStatus;

  constructor(
    private readonly dialogControlService: DialogControlService,
    private readonly commonMenuService: CommonMenuService,
    private readonly superAdminService: SuperAdminService,
    private readonly sharedDriverService: SharedDriverService,
    private readonly toastService: ToastService,
    private readonly  confirmationService: ConfirmationService,
  ) { }

  ngOnInit(){
    this.superAdminService.popupClosed$.subscribe(refresh => {
      if (refresh) {
        this.afterCancelApiCall.emit({result:true});
      }
    });
  }

  showData(rowData: any,event) {
    const actionMap = {
      viewInvoice: () => {
        this.viewInVoice.emit(rowData?.id);
      },
      pay: () => {
        this.dialogControlService.openDialog(PayRepayModalComponent, {
          styleClass: 'pay-repay',
          data: {
            bookingId:null,
            invoiceId: rowData.id,
            driverId:rowData.driverId,
            bookingType:false
          },
        });
        this.dialogControlService.onClose().subscribe(() => {
          this.afterMarkAsPaidOrCancel.emit(true);
          this.afterCancelApiCall.emit(true);
        });
      },
      cancelModal: () => { this.openCancelModal(rowData?.id) },
      shareInvoice: () => {
        this.sendInvoiceOnMail.emit(rowData?.id)
      },
      markAsPaid: (product, event) => {
        this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: MARK_AS_PAID_CONFIRMATION,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.markAsPaidFunc(product?.id);
          },
        });
      },
      paymentReminder: () => this.sendPaymentReminder(rowData?.id)
    };

    const config = [
      {
        label: '',
        icon: '',
        escape: false,
      },
      {
        label: 'View Invoice',
        icon: 'common-icon view-profile',
        escape: false,
        command: actionMap.viewInvoice,
      },
      {
        label: 'Share Invoice',
        icon: 'common-icon share-invoice',
        escape: false,
        command: () => {
          this.dialogControlService.openDialog(SharedInvoicePopupComponent, {
            styleClass: 'shareinvoice-model',
            data: {
              invoiceId: rowData.id,
              email: rowData?.email,
              mobileNumber: rowData?.phoneNumber ? rowData?.countryCode + ' ' + rowData?.phoneNumber : null,
              isBookingExist: false
            },
          });
        },
      },
      {
        label: rowData.status === 'Payment Failed' ? 'Re-Pay' : 'Pay',
        icon: 'common-icon custom-pay',
        visible: rowData.status === 'Pending' || rowData.status === 'Payment Failed',
        command: () => {
          actionMap.pay();
          this.updateBookingStateAfterPay();
        }
      },
      {
        label: 'Cancel',
        icon: 'pi pi-times',
        escape: false,
        visible: !(rowData?.paymentStatus == this.invoicePaymentStatus.Paid || rowData?.paymentStatus == this.invoicePaymentStatus.Cancel || rowData?.paymentStatus == this.invoicePaymentStatus.InProgress),
        command: actionMap.cancelModal,
      },
      {
        label: 'Mark as Paid',
        icon: 'common-icon mark-as-paid',
        escape: false,
        visible: (rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed || rowData?.paymentStatus === this.invoicePaymentStatus.Pending || rowData?.paymentStatus === this.invoicePaymentStatus.CheckoutUrlGenrated),
        command: () => actionMap.markAsPaid(rowData, event),
      },
      {
        label :'Send Payment Reminder',
        icon :'common-icon send-payment-reminder',
        visible: (rowData?.paymentStatus === this.invoicePaymentStatus.PaymentFailed || rowData?.paymentStatus === this.invoicePaymentStatus.Pending),
        command : actionMap.paymentReminder
      }
    ];
    this.items = this.commonMenuService.commonShowData(config);
  }

  private updateBookingStateAfterCancellation(result): void {
    this.afterCancelApiCall.emit(result);
  }

  private updateBookingStateAfterPay(): void {
    this.afterMarkAsPaidOrCancel.emit(true);
    this.afterPayApiCall.emit();
  }

  openCancelModal(bookindId) {
    this.dialogControlService.openDialog(CancelModalComponent, {
      width: '20%',
      data: {
        comingFromInvoice: true,
        invoiceId: bookindId,
        headerText: "Cancel",
        bodyText: CANCEL_INVOICE_CONFIRMATION_MODEL,
      }
    });
    this.dialogControlService.onClose().subscribe((result) => {
      if (result) {
        this.afterMarkAsPaidOrCancel.emit(true);
        this.updateBookingStateAfterCancellation(result);
      };
    });
  }
  markAsPaidFunc(invoiceId: string) {
    let request = {
      invoiceId: invoiceId,
      timeZone: Utility.getLocalTimeZone(),
    };
    this.sharedDriverService.createInvoicePaymentOffline(request).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (_response: any) => {
        this.toastService.showToastMessage(
          'success',
          'Success',
          'Custom invoice has been marked as paid.'
        );
        this.afterMarkAsPaidOrCancel.emit(true);
        this.updateBookingStateAfterPay();
      },
      error: (error) => {
        this.toastService.showToastMessage(
          'error',
          'Error',
          error?.error?.message
        );
      },
    });
  }

  onPageChange(event) {
    this.pageCustomInvoiceList.emit(event)
  }

  sendPaymentReminder(invoiceId): void {
    const bookingAndInvoiceId = [invoiceId];
    this.sendPaymentReminderApiCall(bookingAndInvoiceId);
  }

  sendPaymentReminderApiCall(bookingAndInvoiceId: string[]): void {
    const requestPayload = {
      bookingAndInvoiceIds: bookingAndInvoiceId,
      timezone: Utility.getLocalTimeZone(),
    };
    this.superAdminService
      .sendPaymentReminder(requestPayload)
      .pipe( autoUnsubWith(this.destroyRef)) // Ensure loader is hidden
      .subscribe({
        next: (response: any) => {
          this.handleReminderSuccess(response);
        },
        error: (error) => {
          this.handleReminderError(error);
        },
      });
  }

   getTimeZoneAbbreviation(timeZone: string): string {
    return CommonFunctions.getTimeZoneAbbreviation(timeZone);
  }

  private handleReminderSuccess(response: any): void {
    if (response.message === 'Reminder send successfully') {
      this.toastService.showToastMessage(
        'success',
        'Success',
        'Reminder sent successfully'
      );
    }
  }

  private handleReminderError(error): void {
    this.toastService.showToastMessage(
      'error',
      'Error',
      error.error.message
    );
  }
}
